import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from 'antd';

import { SlackWorkspaceConfig } from '../_detailShared/SlackWorkspaceConfig';
import { SlackManagerTokenConfig } from '../_detailShared/SlackManagerTokenConfig';
import { SlackMemberMatchPanel } from '../_detailShared/SlackMemberMatchPanel';
import { SlackUserConfig } from '../_detailShared/SlackUserConfig';

import * as S from './Communicator.styled';

interface ISettingsDrawerProps {
  groupId: string;
  /** When a student is selected, their personal Slack link is shown too. */
  studentId?: string;
  visible: boolean;
  onClose: () => void;
}

/**
 * Per-group Slack settings, right inside the communicator — the exact same
 * panels the group card mounts on its Общение tab (workspace bot token,
 * manager's personal token, member↔student matching), plus the selected
 * student's Slack link when a student context is active.
 */
export const SettingsDrawer = memo(
  ({ groupId, studentId, visible, onClose }: ISettingsDrawerProps) => {
    const { t } = useTranslation();

    return (
      <Drawer
        title={t('pages.communicator.settingsTitle')}
        width={560}
        visible={visible}
        onClose={onClose}
        destroyOnClose
      >
        {groupId ? (
          <>
            <SlackWorkspaceConfig groupId={groupId} />
            <SlackManagerTokenConfig groupId={groupId} />
            <SlackMemberMatchPanel groupId={groupId} />
            {studentId ? (
              <>
                <S.SectionLabel>
                  {t('pages.communicator.settingsStudent')}
                </S.SectionLabel>
                <SlackUserConfig studentId={studentId} />
              </>
            ) : null}
          </>
        ) : null}
      </Drawer>
    );
  },
);

SettingsDrawer.displayName = 'SettingsDrawer';
